import { gql } from '@apollo/client';
import { t } from '@lingui/macro';
import * as Yup from 'yup';

import { PROVIDER_FULLNAME_REGEXP } from 'Components/ProviderRegisterForm/ProviderRegisterForm.helpers';
import config from 'config/config';
import { phoneFieldValidationSchema } from 'utils/graphql/spSettings';

export const COOPERATION_TYPES = [
  t`Materiał przedstawiający Fixly na Twojej stronie`,
  t`Wpis sponsorowany z odnośnikiem do strony`,
  t`Artykuł ekspercki lub poradnikowy na blogu Fixly`,
  t`Wspólna akcja promocyjna lub marketingowa`,
  t`Inna`,
];

const validationConfig = {
  MAXIMUM_LENGTH: 255,
};

export const referralValidationSchema = Yup.object().shape({
  fullName: Yup.string()
    .required(t`Podaj swoje imię`)
    .min(
      config.PROVIDER_NAME_MIN_LENGTH,
      t`Pole “imię i nazwisko” musi zawierać 2 słowa (min. ${config.PROVIDER_NAME_MIN_LENGTH} znaków)`
    )
    .max(config.PROVIDER_NAME_MAX_LENGTH, t`Pole zawierać może maksymalnie ${config.PROVIDER_NAME_MAX_LENGTH} znaków`)
    .test({
      name: 'fullNamePattern',
      message: t`Pole "imię i nazwisko" zawierać musi co najmniej 2 wyrazy!`,
      test: (value) => PROVIDER_FULLNAME_REGEXP.test(value || ''),
    }),
  linkUrl: Yup.string()
    .required(t`Wpisz adres WWW`)
    .max(validationConfig.MAXIMUM_LENGTH, t`Pole zawierać może maksymalnie ${validationConfig.MAXIMUM_LENGTH} znaków`),
  linkCounter: Yup.string().max(
    validationConfig.MAXIMUM_LENGTH,
    t`Pole zawierać może maksymalnie ${validationConfig.MAXIMUM_LENGTH} znaków`
  ),
  cooperationTypes: Yup.array().of(Yup.string()),
  email: Yup.string()
    .required(t`Podaj adres e-mail`)
    .email(t`Nieprawidłowy adres e-mail`)
    .max(validationConfig.MAXIMUM_LENGTH, t`Pole zawierać może maksymalnie ${validationConfig.MAXIMUM_LENGTH} znaków`),
  phone: phoneFieldValidationSchema,
  content: Yup.string(),
});

export type SendReferralsVars = {
  fullName: string;
  linkUrl: string;
  phone: string;
  email: string;
  linkCounter?: string;
  cooperationTypes?: string[];
  content?: string;
  subscribe?: boolean;
};

export type SendReferralResponse = {
  sendReferralProgramContactRequest: boolean;
};

export const sendReferralMutation = gql`
  mutation sendReferralProgramContactRequest(
    $fullName: String!
    $linkUrl: String!
    $linkCounter: String
    $cooperationTypes: [CooperationTypeEnum!]
    $phone: String!
    $email: String!
    $content: String
    $subscribe: Boolean
  ) {
    sendReferralProgramContactRequest(
      fullName: $fullName
      linkUrl: $linkUrl
      linkCounter: $linkCounter
      cooperationTypes: $cooperationTypes
      phone: $phone
      email: $email
      content: $content
      subscribe: $subscribe
    )
  }
`;
